import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { history, location } from 'react-router-prop-types';
import { bindActionCreators } from 'redux';

import {
  AsyncCreateBet,
  AsyncDialogs,
  AsyncJokerWiz,
} from 'shared/components/AsyncAtgApp';
import * as dialogTypes from 'shared/constants/DialogTypes';
import { createAtgBetParams } from 'shared/proptypes';
import {
  popDialogByType,
  showSubscriptionRequiredDialog,
} from 'shared/redux/actions';
import { dialogs, ui, user } from 'shared/redux/selectors';

const mapStateToProps = state => ({
  isLoggedIn: user.isLoggedIn(state),
  isSubscriber: user.hasSubscription(state),
  isPageVisible: ui.isPageVisible(state),
  isSubscribeDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.SUBSCRIPTION_REQUIRED,
  }),
  isArchiveDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.ATG_ARCHIVE,
  }),
  isJokerWizDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.JOKERWIZ_DIALOG,
  }),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { showSubscriptionRequiredDialog, popDialogByType },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class AtgSubscriptionGatekeeper extends Component {
    static propTypes = {
      betParams: createAtgBetParams,
      jokerWizParams: PropTypes.object,
      errorDialogActive: PropTypes.bool,
      archiveDialogActive: PropTypes.bool,
      history: history.isRequired,
      location: location.isRequired,
    };

    componentDidMount() {
      const {
        isLoggedIn,
        isSubscriber,
        history,
        location,
        showSubscriptionRequiredDialog,
      } = this.props;

      if (!isLoggedIn) {
        history.replace('/login', { referrer: location });
      } else if (!isSubscriber) {
        showSubscriptionRequiredDialog();
      }
    }

    componentWillUnmount() {
      if (this.props.isSubscribeDialogActive) {
        this.props.popDialogByType(dialogTypes.SUBSCRIPTION_REQUIRED);
      }
    }

    componentDidUpdate(prevProps) {
      const {
        isSubscribeDialogActive,
        isArchiveDialogActive,
        isJokerWizDialogActive,
        errorDialogActive,
        betParams,
        jokerWizParams,
        history,
        popDialogByType,
      } = this.props;

      let clearState = false;

      // When the subscribe dialog is closed we clear the pending action
      // that requires a subscription
      if (!isSubscribeDialogActive && prevProps.isSubscribeDialogActive) {
        clearState = true;
      }

      // If an error dialog is shown while creating a bet we clear the state
      // to avoid having the create bet popup appear again until user tries again
      if (errorDialogActive && (betParams || jokerWizParams)) {
        clearState = true;
      }

      // Clear state when the Joker Wiz dialog is closed
      if (!isJokerWizDialogActive && prevProps.isJokerWizDialogActive) {
        clearState = true;
      }

      if (clearState) {
        if (isArchiveDialogActive) {
          popDialogByType(dialogTypes.ATG_ARCHIVE);
        }
        if (isJokerWizDialogActive) {
          popDialogByType(dialogTypes.JOKERWIZ_DIALOG);
        }
        history.replace('/');
      }
    }

    render() {
      const { isSubscriber, betParams, jokerWizParams, archiveDialogActive } =
        this.props;

      if (isSubscriber) {
        if (betParams) {
          return <AsyncCreateBet betParams={betParams} />;
        } else if (jokerWizParams) {
          return <AsyncJokerWiz betParams={jokerWizParams} />;
        } else if (archiveDialogActive) {
          return <AsyncDialogs />;
        }
      }

      return null;
    }
  },
);
